import { Eye, ChevronDown } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from './ui/popover';

export const ViewMenu = ({ prefix, className, children }) => <Popover>
  <PopoverTrigger className={`view-menu-trigger ${className || ''}`} data-testid={`${prefix}-view-menu`}><Eye size={18} aria-hidden="true" /><span>View</span><ChevronDown size={14} aria-hidden="true" /></PopoverTrigger>
  <PopoverContent className="view-menu-content" side="right" align="start" sideOffset={8} collisionPadding={12} data-testid={`${prefix}-view-options`} aria-label="View options">{children}</PopoverContent>
</Popover>;